import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHeader, Panel } from "@/components/dash";
import { inputCls } from "@/components/admin/AdminLayout";

export default function AdminEnquiries() {
  const { data = [], refetch } = useQuery({ queryKey: ["enquiries"], queryFn: async () => (await api.get("/admin/enquiries")).data });
  const set = async (id, status) => { await api.put(`/admin/enquiries/${id}`, { status }); refetch(); };
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="CMS · Enquiries" title="Enquiries" desc="Contact, Tech Transfer and Plant Advisory form submissions. Each one is also emailed to the admin alert address." />
      <div className="space-y-3" data-testid="enquiries-list">
        {data.length === 0 && <Panel><p className="text-sm text-slate-400">No enquiries yet.</p></Panel>}
        {data.map((e) => (
          <Panel key={e.id} title={`${e.name} · ${e.topic}`} sub={`${e.email} · ${e.company || "—"} · ${e.country || "—"} · ${e.phone || ""} · ${e.created_at.slice(0, 16).replace("T", " ")}`}
            right={<select className={`${inputCls} h-8 text-xs`} value={e.status} onChange={(ev) => set(e.id, ev.target.value)} data-testid={`enquiry-status-${e.id}`}>{["new", "in progress", "closed"].map((s) => <option key={s}>{s}</option>)}</select>}>
            {e.project_stage && <p className="text-xs text-[#03AB9E] mb-2">Stage: {e.project_stage}</p>}
            <p className="text-sm text-slate-300 whitespace-pre-wrap">{e.message}</p>
          </Panel>
        ))}
      </div>
    </div>
  );
}
